import 'Sass/views/policy-index.scss';

(function () {
    'use strict';

    //// scroll to search results if any exist on page
    if (window.location.href.indexOf('?') !== -1) {
        var form = $('form');

        //This checks that a form parameter exists
        if (form.length > 0) {
            $('html, body').animate({
                scrollTop: form.offset().top + form.height() - 50
            }, 300);
        }
    }

    // it's not very Angular, but as the page is server-rendered, can hide/show elements 
    // as they all exist in the markup all the time
    function policyindex($window) {

        let policyNodes = [];
        let nestedAccordions = [];
        let rootAccordions = [];

        const reducer = (acc, val) => acc + val;

        this.filter = key => {
            let showAll = this[key].toLowerCase() === 'all';

            for (let policy of policyNodes) {
                policy.dataset[key + 'Hidden'] = showAll ? false : !policy.dataset[key].includes(this[key]);                
            }

            for (let nested of nestedAccordions) {
                let documents = nested.querySelectorAll('.policy-block');
                let hiddenDocuments = Array.from(documents).filter(x => window.getComputedStyle(x).display === 'none');

                let visibleCount = documents.length - hiddenDocuments.length;
                nested.querySelector('count').innerText = visibleCount;

                nested.classList[visibleCount === 0 ? 'add' : 'remove']('disabled');
            }

            for (let root of rootAccordions) {
                let nested = root.querySelectorAll('.accordion-nested .panel');
                 
                let visibleCount = Array.from(nested).map(x => +x.querySelector('count').innerText).reduce(reducer);
                root.querySelector('count').innerText = visibleCount;
                root.classList[visibleCount === 0 ? 'add' : 'remove']('disabled');
            }
        }

        $window.onload = () => {
            policyNodes = document.querySelectorAll('.policy-block');
            nestedAccordions = document.querySelectorAll('.accordion-nested .panel');
            rootAccordions = document.querySelectorAll('.accordion-has-nested > .panel-group > .panel');

            if (this.area)
                this.filter('area');

            if (this.type)
                this.filter('type');

            if (this.category)
                this.filter('category');
        };        
    }

    angular.module('Uscapp').controller('policyIndexCtrl', ['$window', policyindex]);

})();